import { Tooltip } from "primereact/tooltip";
import { useTranslation } from 'react-i18next';
export function Timer(props) {
  const { timeString, isLate } = props;
  const{t}=useTranslation();
  const ELAPSED_TIME=t("ELAPSED_TIME")
  return (
    <div
      style={{
        color: isLate ? "#D20000" : "#2fe90f"
      }}
      className="flex justify-content-center align-items-center font-bold gap-2 time-tooltip"
      data-pr-tooltip={ELAPSED_TIME}
    >
      <Tooltip target={`.time-tooltip`} />
      <i className="pi pi-clock"></i>
      <label>{timeString}</label>
    </div>
  );
}
